import type { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
import { Button } from '@mantine/core';
// components
import Header from '@/components/Layout/components/Header';
import ProjectBreadcrumb from '@/modules/Projects/components/ProjectBreadcrumb/ProjectBreadcrumb';
import FilesTab from '@/pages/Project/components/Files';
import ActiveVersionIndicator from '@/pages/Project/components/ActiveVersionIndicator';
import Sandbox from '@/pages/Project/components/Sandbox';
// utils
import useSandboxStore from '@/modules/Sandbox/Sandbox.store.ts';
import { useProjectQuery } from '@/services/designer/projects/projects.queries';
import { PageContainer } from '@/components/PageContainer/PageContainer.tsx';

const Project: FC = () => {
    const { projectId } = useParams();
    const { data: project } = useProjectQuery(true, projectId);
    const isChatOpened = useSandboxStore((state) => state.isChatOpened);
    const toggleChat = useSandboxStore((state) => state.toggleChat);

    return (
        <>
            <Helmet>
                <title>NEWO - Project</title>
            </Helmet>

            <PageContainer className="flex flex-col px-0" h="100%" w="100%">
                <Header
                    breadcrumbs={[
                        {
                            label: <ProjectBreadcrumb projectId={projectId} />
                        }
                    ]}
                    isPublishAllVisible={false}
                >
                    <ActiveVersionIndicator projectIdn={project?.idn} />
                    <Button
                        className="ml-auto"
                        size="xs"
                        variant="outline"
                        onClick={toggleChat}
                    >
                        Sandbox: {isChatOpened ? 'On' : 'Off'}
                    </Button>
                </Header>
                <div className="min-h-0 flex-1">
                    <FilesTab projectIdn={project?.idn} />
                </div>
                <Sandbox />
            </PageContainer>
        </>
    );
};

export default Project;
